<template>
  <div>
    <b-modal ref="modal-payment-info" id="modal-payment" :no-close-on-backdrop="preventClose"
      :no-close-on-esc="preventClose" :hide-header-close="hideHeaderClose">
      <template #modal-title>
        <span class="font-bold text-xl my-2">Actualizar a Premium</span>
      </template>
      <p class="my-2">
        Desbloquea beneficios exclusivos con nuestra suscripción Premium:
      </p>
      <div class="mt-4 overflow-x-auto">
        <table class="w-full border-collapse text-sm">
          <thead>
            <tr>
              <th class="text-left p-2 border-b border-gray-300 font-semibold">Funcionalidad</th>
              <th class="text-center p-2 border-b border-gray-300 font-semibold">Plan Grátis</th>
              <th class="text-center p-2 border-b border-gray-300 font-semibold bg-yellow-100">Plan Premium</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td class="p-2 border-b border-gray-200">Acceso a la plataforma</td>
              <td class="p-2 border-b border-gray-200 text-center">Acceso básico</td>
              <td class="p-2 border-b border-gray-200 text-center bg-yellow-50">Acceso completo</td>
            </tr>
            <tr>
              <td class="p-2 border-b border-gray-200">Cursos disponibles</td>
              <td class="p-2 border-b border-gray-200 text-center">5 cursos</td>
              <td class="p-2 border-b border-gray-200 text-center bg-yellow-50">10+ cursos</td>
            </tr>
            <tr>
              <td class="p-2 border-b border-gray-200">Lecciones disponibles</td>
              <td class="p-2 border-b border-gray-200 text-center">40 lecciones</td>
              <td class="p-2 border-b border-gray-200 text-center bg-yellow-50">200+ lecciones</td>
            </tr>
            <tr>
              <td class="p-2 border-b border-gray-200">Lecciones premium</td>
              <td class="p-2 border-b border-gray-200 text-center">No incluidas</td>
              <td class="p-2 border-b border-gray-200 text-center bg-yellow-50">Incluidas</td>
            </tr>
            <tr>
              <td class="p-2 border-b border-gray-200">Preguntas disponibles</td>
              <td class="p-2 border-b border-gray-200 text-center">150 preguntas</td>
              <td class="p-2 border-b border-gray-200 text-center bg-yellow-50">1.500+ preguntas</td>
            </tr>
            <tr>
              <td class="p-2 border-b border-gray-200">Simulacros disponibles</td>
              <td class="p-2 border-b border-gray-200 text-center">5 simulacros</td>
              <td class="p-2 border-b border-gray-200 text-center bg-yellow-50">20+ simulacros</td>
            </tr>
            <tr>
              <td class="p-2 border-b border-gray-200">Presentar simulacros</td>
              <td class="p-2 border-b border-gray-200 text-center">Sí</td>
              <td class="p-2 border-b border-gray-200 text-center bg-yellow-50">Sí</td>
            </tr>
            <tr>
              <td class="p-2 border-b border-gray-200">Revisión de simulacros</td>
              <td class="p-2 border-b border-gray-200 text-center">No disponible</td>
              <td class="p-2 border-b border-gray-200 text-center bg-yellow-50">Revisión completa al finalizar</td>
            </tr>
            <tr>
              <td class="p-2 border-b border-gray-200">Reportes generales de desempeño</td>
              <td class="p-2 border-b border-gray-200 text-center">No disponible</td>
              <td class="p-2 border-b border-gray-200 text-center bg-yellow-50">Incluidos</td>
            </tr>
            <tr>
              <td class="p-2 border-b border-gray-200">Reportes por curso</td>
              <td class="p-2 border-b border-gray-200 text-center">No disponibles</td>
              <td class="p-2 border-b border-gray-200 text-center bg-yellow-50">Incluidos</td>
            </tr>
            <tr>
              <td class="p-2 border-b border-gray-200">Seguimiento del progreso</td>
              <td class="p-2 border-b border-gray-200 text-center">Básico</td>
              <td class="p-2 border-b border-gray-200 text-center bg-yellow-50">Avanzado</td>
            </tr>
            <tr>
              <td class="p-2 border-gray-200"></td>
              <td class="p-2 border-gray-200 text-center">
              </td>
              <td class="p-2 border-gray-200 text-center bg-yellow-50">
                <div class="price-wrapper flex flex-col items-center">
                  <div class="flex font-bold items-center mt-2">
                    <span class="text-4xl"> ${{ getPrice() }} </span>
                    <span class="ml-2">{{ mercadoPagoPreference?.currency || "USD" }}</span>
                  </div>
                  <p class="text-sm">Anualmente</p>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- <div
        class="flex items-center p-3 bg-neutral-400 bg-opacity-10 rounded-lg mt-4"
      >
        <Icon icon="bxl:zoom" style="color: black" class="text-3xl mr-2" />
        <p class="m-0">
          <strong>10 clases exclusivas en vivo</strong> con ingenieros de
          compañías globales
        </p>
      </div> -->

      <!-- <div class="flex justify-center gap-5 mt-4 mb-3">
        <Icon icon="bxl:google" class="text-3xl text-black" />
        <Icon icon="bxl:apple" class="text-3xl text-black" />
        <Icon icon="bxl:amazon" class="text-3xl text-black" />
        <Icon icon="bxl:meta" class="text-3xl text-black" />
        <Icon icon="bxl:microsoft" class="text-3xl text-black" />
      </div> -->

      <!-- <div class="price-wrapper flex flex-col items-center">
        <div class="flex font-bold items-center mt-2">
          <span class="text-4xl"> ${{ getPrice() }} </span>
          <span class="ml-2">{{ mercadoPagoPreference.currency }}</span>
        </div>
        <p class="text-sm">Anualmente</p>
      </div> -->

      <div class="text-center text-secondary text-xs mt-3">
        * Su pago está sujeto a impuestos de su país.
      </div>

      <template #modal-footer>
        <div class="flex gap-3 justify-end w-full">
          <button
            v-if="showLaterButton"
            class="mob-btn mob-cta-gold-outline rounded-lg"
            @click="goToLastSection()"
          >
            Quizás más tarde
          </button>
          <button
            class="mob-btn mob-cta-gold rounded-lg"
            @click="openPaymentGatewayModal()"
          >
            Actualizar ahora
          </button>
        </div>
      </template>
    </b-modal>

    <!-- Modal selección de pasarela de pago -->
    <b-modal
      ref="payment-gateway-modal"
      id="modal-payment-gateway"
      hide-header-close
      centered
    >
      <template #modal-title>
        <span class="font-bold text-xl my-2">Selecciona tu método de pago</span>
      </template>

      <p class="my-2">
        ¿Cómo deseas pagar tu suscripción Premium? Escoge una opción:
      </p>

      <div class="grid grid-cols-1 md:grid-cols-2 gap-4 mt-4">
        <!-- Opción Mercado Pago -->
        <div class="border rounded-xl p-4 shadow-sm bg-white flex flex-col items-center text-center">
          <div class="text-lg font-semibold mb-1">Pagos en moneda colombiana</div>
          <!-- <div class="text-xs text-gray-600 mb-3">Pago en COP (Colombia)</div> -->
          <button
            class="mob-btn mob-cta-gold rounded-lg w-full mb-2"
            @click="payWithMercadoPago()"
          >
            Pagar en Pesos Colombianos
          </button>
          <!-- <div class="text-xs text-gray-500 flex items-center justify-center">
            <span>Se cobrará en Pesos Colombianos</span>
          </div> -->
        </div>

        <!-- Opción Lemon Squeezy -->
        <div class="border rounded-xl p-4 shadow-sm bg-white flex flex-col items-center text-center">
          <div class="text-lg font-semibold mb-4">Pago en dólares</div>
          <!-- <div class="text-xs text-gray-600 mb-3">Pago internacional (USD)</div> -->
          <button
            class="mob-btn mob-cta-gold rounded-lg w-full mb-2 mt-2"
            @click="payWithLemonSqueezy()"
          >
            Pagar en Dólares Estadounidenses
          </button>
          <!-- <div class="text-xs text-gray-500 flex items-center justify-center">
            <span>Se cobrará en Dólares Estadounidenses</span>
          </div> -->
        </div>
      </div>

      <template #modal-footer>
        <div class="flex justify-end w-full">
          <button
            class="mob-btn mob-cta-gold-outline rounded-lg"
            @click="$refs['payment-gateway-modal'].hide()"
          >
            Cerrar
          </button>
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
import { Icon } from "@iconify/vue2";
import {
  createMercadoPagoPreference,
  createLemonSqueezyCheckout,
} from "@/services/payment.service";

export default {
  name: "MobPaymentModal",

  props: {
    preventClose: {
      type: Boolean,
      default: false,
    },
    hideHeaderClose: {
      type: Boolean,
      default: false,
    },
    showLaterButton: {
      type: Boolean,
      default: false,
    },
  },

  components: {
    Icon,
  },

  data() {
    return {
      mercadoPagoPreference: {},
    };
  },

  methods: {
    getPrice() {
      if (isNaN(this.mercadoPagoPreference?.amount)) {
        return 0;
      }

      var formatter = new Intl.NumberFormat({
        style: "currency",
        currency: this.mercadoPagoPreference.currency,
        minimumFractionDigits: 0,
      });
      return formatter.format(this.mercadoPagoPreference.amount);
    },

    openPaymentGatewayModal() {
      this.$refs["payment-gateway-modal"].show();
    },

    async payWithMercadoPago() {
      if (!this.mercadoPagoPreference.initPoint) {
        await this.loadMercadoPagoPreference();
      }

      if (this.mercadoPagoPreference.initPoint) {
        window.location.href = this.mercadoPagoPreference.initPoint;
      }
    },

    async payWithLemonSqueezy() {
      try {
        const checkout = await createLemonSqueezyCheckout();
        if (checkout && checkout.checkoutUrl) {
          window.location.href = checkout.checkoutUrl;
        }
      } catch (error) {
        // Por ahora solo logueamos; se puede mejorar con notificaciones al usuario
        // eslint-disable-next-line no-console
        console.error("Error creando checkout de Lemon Squeezy", error);
      }
    },

    async showModalPayment() {
      this.$refs["modal-payment-info"].show();

      await this.loadMercadoPagoPreference();
    },

    async loadMercadoPagoPreference() {
      this.mercadoPagoPreference = await createMercadoPagoPreference();
    },
    goToLastSection() {
      // Cerrar el modal primero
      this.$refs["modal-payment-info"].hide();

      // Obtener la ruta anterior desde el store (guardada por el router.beforeEach)
      const previousRoute = this.$store.state.previousRoute;

      // Si existe una ruta anterior, navegar allí, sino al dashboard por defecto
      const route = previousRoute && previousRoute !== "/" ? previousRoute : "/dashboard";
      this.$router.push(route).catch(() => { });
    },
  },
};
</script>

<style>
#modal-payment .modal-dialog {
  width: 95%;
  max-width: 600px !important;
  margin: 1rem auto;
  max-height: calc(100vh - 2rem);
}

#modal-payment .modal-content {
  display: flex;
  flex-direction: column;
  max-height: 100%;
}

#modal-payment .modal-body {
  flex: 1 1 auto;
  overflow-y: auto;
}

#modal-payment .modal-header {
  border-bottom-color: #f6e1c8;
}

#modal-payment___BV_modal_footer_ {
  border-top-color: #f6e1c8;
}

@media (max-width: 576px) {
  #modal-payment .modal-dialog {
    margin: 0.5rem auto;
    width: 100%;
  }

  #modal-payment table {
    font-size: 0.8rem;
  }

  #modal-payment th,
  #modal-payment td {
    padding: 0.35rem;
  }
}
</style>

<style src="@/assets/css/bootstrap-modal.css"></style>
<style src="@/assets/css/bootstrap-custom.css" scoped></style>
